module.exports = __webpack_public_path__ + "static/media/20250225_091951.9da4bd5f.webp";